import { useTranslation } from 'react-i18next';
import { intervalToDuration } from 'date-fns';

export const useConvertSecondsToDHMinSec = (timeToUnlockInSeconds: number) => {
  const { t } = useTranslation();

  const { days, hours, minutes, seconds } = intervalToDuration({
    start: 0,
    end: timeToUnlockInSeconds * 1000
  });

  let dateFormat = '';
  if (days) {
    dateFormat += `${days}${t('pages.mymes.details.unlock_blob_in_days_form')} `;
  }
  if (hours) {
    dateFormat += `${hours}${t('pages.mymes.details.unlock_blob_in_hours_form')} `;
  }
  if (minutes) {
    dateFormat += `${minutes}${t('pages.mymes.details.unlock_blob_in_minutes_form')} `;
  }
  if (seconds) {
    dateFormat += `${seconds}${t('pages.mymes.details.unlock_blob_in_seconds_form')}`;
  }

  return dateFormat;
};
